import React, { useRef, useEffect } from 'react';

export default function UnifiedInputComposer({
  value,
  onChangeText,
  onSend,
  placeholder,
  disabled = false,
  sendDisabled,
  showAttachment = false,
  onAttachmentPress,
  attachmentDisabled = false,
}) {
  const isSendDisabled = typeof sendDisabled === 'boolean' ? sendDisabled : disabled;
  const textareaRef = useRef(null);

  // Auto-grow heights smoothly based on text volume (Exactly how ChatGPT/Gemini does it)
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const handleKeyDown = (e) => {
    // If the user hits enter WITHOUT pressing shift, submit!
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); 
      if (!isSendDisabled && value.trim()) {
        onSend(e);
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end', // Keeps attachment + arrow cleanly aligned when input text wraps
        gap: 8,
        background: 'transparent',
        padding: '6px 4px',
        width: '100%',
      }}
    >
      {showAttachment && (
        <button
          type="button"
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            marginBottom: 6, // Aligns to text input baseline
            cursor: attachmentDisabled ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            height: 24,
            width: 24,
            justifyContent: 'center',
            outline: 'none',
          }}
          onClick={onAttachmentPress}
          disabled={attachmentDisabled}
          aria-label="Add attachment"
        >
          <div style={{ position: 'relative', width: 16, height: 16, opacity: attachmentDisabled ? 0.3 : 1 }}>
            <div style={{ position: 'absolute', top: 7, left: 0, width: 16, height: 2, backgroundColor: '#000' }} />
            <div style={{ position: 'absolute', top: 0, left: 7, width: 2, height: 16, backgroundColor: '#000' }} />
          </div>
        </button>
      )}
      
      <textarea
        ref={textareaRef}
        value={value}
        onChange={e => onChangeText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        rows={1}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          fontSize: 16,
          lineHeight: '24px',
          maxHeight: 200,
          resize: 'none', // Prevents user manual resize thumb from causing layout errors
          padding: '6px 0',
          color: '#000',
          fontFamily: 'inherit',
        }}
      />

      <button
        type="button"
        style={{
          background: isSendDisabled ? '#e2e2e5' : 'white',
          color: isSendDisabled ? '#a1a1aa' : '#000000',
          border: 'none',
          borderRadius: '50%',
          width: 32,
          height: 32,
          minWidth: 32,
          fontSize: 16,
          fontWeight: 'bold',
          cursor: isSendDisabled ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s, color 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          marginBottom: 2,
        }}
        disabled={isSendDisabled}
        onClick={onSend}
        aria-label="Send message"
      >
        ↑
      </button>
    </div>
  );
}